import { render } from "./UpdateProfileInformationForm.vue?vue&type=template&id=f12f9b90&scoped=true"
import script from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"
export * from "./UpdateProfileInformationForm.vue?vue&type=script&lang=js"

import "./UpdateProfileInformationForm.vue?vue&type=style&index=0&id=f12f9b90&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f12f9b90"]])

export default __exports__